import ForgotNext from '@/components/RegAndForgot/ForgotNext';
const ForgetNext = () => {
    const element = (<><ForgotNext /></>);
    return element
}
export default ForgetNext